export default "__VITE_ASSET__H6fwCX4h__"